"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eval_fmt = void 0;
var tokenizer_1 = require("../core/tokenizer");
var regulator_1 = require("../core/regulator");
var parser_1 = require("../core/parser");
var number_transfer_1 = require("../core/number-transfer");
var calculation_1 = require("../core/calculation");
var constant_1 = require("../constant");
/**
 * 对格式串进行分词、调整、解析、求值、拼接过程获得最终值
 * TODO: 函数名向外暴露, 后期修改
 * @param format 格式串
 * @param value 输入值
 * @param formatListLength 格式串数组长度
 * @param dateOptions 其他选项
 */
function eval_fmt(format, value, formatListLength, dateOptions) {
    // 进行分词
    var tokenizer = new tokenizer_1.Tokenizer(format, value, formatListLength, dateOptions);
    tokenizer.run();
    var _a = tokenizer.getTokenizedResult(), formatDate = _a.formatDate, hourSystemType = _a.hourSystemType, tokenizedList = _a.tokenizedList;
    // 判断解析是否无法解析
    if (!tokenizer.isValid) {
        return [constant_1.INVALID_VALUE, null];
    }
    // 准备解析所需环境变量
    var parserContext = {
        formatDate: formatDate,
        hourSystemType: hourSystemType,
        subsecondDecimalNumber: 0,
    };
    // 若解析为日期格式需要进行调整
    if (!!formatDate) {
        var regulator = new regulator_1.Regulator(tokenizedList, hourSystemType);
        regulator.run();
        parserContext.subsecondDecimalNumber = regulator.getRegulatedResult();
    }
    // 进行解析
    var parser = new parser_1.Parser(value, tokenizedList, parserContext);
    parser.run();
    var _b = parser.getParsedResult(), parsedNumberString = _b.parsedNumberString, outputNumType = _b.outputNumType, needCutEndPercentageLabel = _b.needCutEndPercentageLabel, numberFormatTokenIndexes = _b.numberFormatTokenIndexes, colorFormat = _b.colorFormat;
    // 如果解析结果存在数值类格式串, 对其进行求值
    if (!!parsedNumberString) {
        var calculateContext = {
            parsedNumberString: parsedNumberString,
            needCutEndPercentageLabel: needCutEndPercentageLabel,
            numberFormatTokenIndexes: numberFormatTokenIndexes,
            formatListLength: formatListLength,
        };
        calculation_1.calculateNumberFormat(value, tokenizedList, calculateContext);
    }
    // 转换数字格式
    if (outputNumType !== constant_1.NumberLanguageCaseType.Default) {
        number_transfer_1.numberTransfer(tokenizedList, outputNumType);
    }
    // 拼接分词数组
    var evaluatedValue = tokenizedList.reduce(function (finalValue, currentToken) { return (currentToken !== null ? finalValue + currentToken.value : finalValue); }, '');
    return [evaluatedValue, colorFormat];
}
exports.eval_fmt = eval_fmt;
//# sourceMappingURL=evaluate-format.js.map